"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerComponent = ContainerComponent;
const React = __importStar(require("react"));
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Actions = __importStar(require("./actions"));
const elements_1 = require("./elements");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const data_1 = require("./data");
const calculate_component_1 = require("./calculate-component");
const loaders_1 = require("@genesys/client-core/lib/loaders");
function ContainerComponent(props) {
    const caseSelectors = Object.entries(props.propertiesSelectors).filter(([id, _v]) => id.startsWith("case"));
    return (React.createElement(Contexts.clientConfigContext.Consumer, null, config => (React.createElement(elements_1.Root, null,
        React.createElement(calculate_component_1.CalculateComponent, { authorization: config.authorization, graphqlEndpoint: config.graphqlEndpoint, state: props, onParseResults: result => props.dispatch(Actions.parseResult(result)) }),
        React.createElement(elements_1.InputContainer, null,
            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer
            // biome-ignore lint: -
            , { 
                // biome-ignore lint: -
                selectedProperties: props.propertiesSelectors["config"], productProperties: data_1.configPropertyInfo, screenAmountProfileFieldGroup: "OilonTool", onChange: (pvs) => props.dispatch(Actions.setProperties("config", pvs)), showGroups: false, uniqueId: "oilon_config" }),
            React.createElement(elements_1.ButtonsContainer, null,
                React.createElement("button", { onClick: () => props.dispatch(Actions.addCase()) }, "Add Case"),
                React.createElement("button", { onClick: () => props.dispatch(Actions.calculate()) }, "Calculate")),
            React.createElement(elements_1.CasesContainer, null, caseSelectors.map(([id, pvs], ix) => (React.createElement(elements_1.CaseContainer, { key: id + ix },
                React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: pvs, productProperties: data_1.calculationCasePropertyInfo, screenAmountProfileFieldGroup: "OilonTool", onChange: (pvs) => props.dispatch(Actions.setProperties(id, pvs)), showGroups: false, uniqueId: "oilon_" + id }),
                ix > 0 && (React.createElement(elements_1.DeleteButtonContainer, null,
                    React.createElement("button", { onClick: () => props.dispatch(Actions.deleteCase(id)) }, "Delete case")))))))),
        props.isLoading && (React.createElement(elements_1.SpinnerContainer, null,
            React.createElement(loaders_1.PleaseWaitOverlayLoaderIndicator, { active: props.isLoading, children: React.createElement(React.Fragment, null) }))),
        props.results && (React.createElement(elements_1.ResultContainer, null,
            React.createElement(elements_1.ErrorsContainer, null, props.results.errors.map((e, ix) => (React.createElement("p", { key: "error" + ix }, e)))),
            React.createElement(elements_1.CasesContainer, null, props.results.calculationCaseResults.map((pvs, ix) => (React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { key: "case-result-" + ix, selectedProperties: pvs, productProperties: data_1.calculationCaseResultPropertyInfo, screenAmountProfileFieldGroup: "OilonTool", onChange: (pvs) => props.dispatch(Actions.setProperties("case-result-" + ix, pvs)), showGroups: false, uniqueId: "oilon_result" + ix, hidePropertyNames: ix > 0, readOnlyProperties: Object.keys(pvs) }))))))))));
}
//# sourceMappingURL=container-component.js.map